import { Layout, Button, Typography, Space, App as AntApp } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { ThemeToggle } from "../ThemeToggle";
import { useLogoutMutation } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import type { MeResponse } from "@/api/types";
import { sanitizeDisplayName } from "@/utils/sanitize";

interface Props {
  me: MeResponse;
}

export function AppHeader({ me }: Props) {
  const navigate = useNavigate();
  const logoutMutation = useLogoutMutation();
  const { message } = AntApp.useApp();

  const handleLogout = async () => {
    try {
      await logoutMutation.mutateAsync();
      message.success("Вы вышли из системы");
      navigate("/login", { replace: true });
    } catch {
      // Ошибка уже залогирована/показана глобальным interceptor'ом, но клиент уже
      // почищен (см. useLogoutMutation.onError). Просто переходим на /login.
      navigate("/login", { replace: true });
    }
  };

  return (
    <Layout.Header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        borderBottom: "1px solid rgba(127,127,127,0.15)",
      }}
    >
      <Typography.Text strong style={{ fontSize: 18 }}>
        Bionika Multitool
      </Typography.Text>
      <Space size={16}>
        <Typography.Text type="secondary" data-testid="header-user-email">
          {sanitizeDisplayName(me.name) || sanitizeDisplayName(me.email)}
        </Typography.Text>
        <ThemeToggle />
        <Button
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          loading={logoutMutation.isPending}
        >
          Выход
        </Button>
      </Space>
    </Layout.Header>
  );
}
